// Metro Distance Service - Static database approach
// This can be easily replaced with Google Maps API or other services later

/** Manual nearest-station copy when auto lookup is wrong or unavailable. */
const VENUE_METRO_OVERRIDES = {
  '660e8400-e29b-41d4-a716-446655440007': {
    station: 'Goodge Street',
    walkingTime: 5,
    city: 'London'
  },
  '660e8400-e29b-41d4-a716-446655440023': {
    station: 'Nine Elms',
    walkingTime: 4,
    city: 'London'
  },
  '660e8400-e29b-41d4-a716-446655440054': {
    station: 'Chancery Lane',
    walkingTime: 2,
    city: 'London'
  }
};

const resolveVenueId = (venue) =>
  String(venue?.id ?? venue?.venue_id ?? venue?.venueId ?? '').trim();

const normalizeVenueNameKey = (name) =>
  String(name || '')
    .toLowerCase()
    .trim()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

/** Fallback when API record has no address/coordinates (match by venue name). */
const VENUE_METRO_OVERRIDES_BY_NAME = {
  'london-art-bar': {
    station: 'Chancery Lane',
    walkingTime: 2,
    city: 'London'
  }
};

// Metro stations database with coordinates
const METRO_STATIONS_DB = {
  'London': [
    { name: 'Acton Town', lat: 51.5028, lng: -0.2801 },
    { name: 'Aldgate', lat: 51.5143, lng: -0.0755 },
    { name: 'Aldgate East', lat: 51.5154, lng: -0.0726 },
    { name: 'All Saints', lat: 51.5107, lng: -0.013 },
    { name: 'Alperton', lat: 51.5407, lng: -0.2997 },
    { name: 'Amersham', lat: 51.6736, lng: -0.607 },
    { name: 'Angel', lat: 51.5322, lng: -0.1058 },
    { name: 'Archway', lat: 51.5653, lng: -0.1353 },
    { name: 'Arnos Grove', lat: 51.6164, lng: -0.1331 },
    { name: 'Arsenal', lat: 51.5586, lng: -0.1059 },
    { name: 'Baker Street', lat: 51.5226, lng: -0.1571 },
    { name: 'Balham', lat: 51.4431, lng: -0.1525 },
    { name: 'Bank', lat: 51.5133, lng: -0.0886 },
    { name: 'Barbican', lat: 51.5204, lng: -0.0979 },
    { name: 'Barking', lat: 51.5396, lng: 0.081 },
    { name: 'Barkingside', lat: 51.5856, lng: 0.0887 },
    { name: 'Barons Court', lat: 51.4905, lng: -0.2139 },
    { name: 'Battersea Power Station', lat: 51.4816, lng: -0.1445 },
    { name: 'Bayswater', lat: 51.5121, lng: -0.1879 },
    { name: 'Beckton', lat: 51.5148, lng: 0.0613 },
    { name: 'Beckton Park', lat: 51.5087, lng: 0.055 },
    { name: 'Becontree', lat: 51.5403, lng: 0.127 },
    { name: 'Belsize Park', lat: 51.5504, lng: -0.1642 },
    { name: 'Bermondsey', lat: 51.4979, lng: -0.0637 },
    { name: 'Bethnal Green', lat: 51.527, lng: -0.0549 },
    { name: 'Blackfriars', lat: 51.512, lng: -0.1031 },
    { name: 'Blackhorse Road', lat: 51.5867, lng: -0.0417 },
    { name: 'Blackwall', lat: 51.5079, lng: -0.0066 },
    { name: 'Bond Street', lat: 51.5142, lng: -0.1494 },
    { name: 'Borough', lat: 51.5011, lng: -0.0943 },
    { name: 'Boston Manor', lat: 51.4956, lng: -0.325 },
    { name: 'Bounds Green', lat: 51.6071, lng: -0.1243 },
    { name: 'Bow Church', lat: 51.5273, lng: -0.0208 },
    { name: 'Bow Road', lat: 51.5269, lng: -0.0247 },
    { name: 'Brent Cross', lat: 51.5766, lng: -0.2136 },
    { name: 'Brixton', lat: 51.4627, lng: -0.1145 },
    { name: 'Bromley-By-Bow', lat: 51.5248, lng: -0.0119 },
    { name: 'Buckhurst Hill', lat: 51.6266, lng: 0.0471 },
    { name: 'Burnt Oak', lat: 51.6028, lng: -0.2641 },
    { name: 'Caledonian Road', lat: 51.5481, lng: -0.1188 },
    { name: 'Camden Town', lat: 51.5392, lng: -0.1426 },
    { name: 'Canada Water', lat: 51.4982, lng: -0.0502 },
    { name: 'Canary Wharf', lat: 51.5051, lng: -0.0209 },
    { name: 'Canning Town', lat: 51.5147, lng: 0.0082 },
    { name: 'Cannon Street', lat: 51.5113, lng: -0.0904 },
    { name: 'Canons Park', lat: 51.6078, lng: -0.2947 },
    { name: 'Chalfont & Latimer', lat: 51.6679, lng: -0.561 },
    { name: 'Chalk Farm', lat: 51.5441, lng: -0.1538 },
    { name: 'Chancery Lane', lat: 51.5185, lng: -0.1111 },
    { name: 'Charing Cross', lat: 51.508, lng: -0.1247 },
    { name: 'Chesham', lat: 51.7052, lng: -0.611 },
    { name: 'Chigwell', lat: 51.6177, lng: 0.0755 },
    { name: 'Chiswick Park', lat: 51.4946, lng: -0.2678 },
    { name: 'Chorleywood', lat: 51.6543, lng: -0.5183 },
    { name: 'Clapham Common', lat: 51.4618, lng: -0.1384 },
    { name: 'Clapham North', lat: 51.4649, lng: -0.1299 },
    { name: 'Clapham South', lat: 51.4527, lng: -0.148 },
    { name: 'Cockfosters', lat: 51.6517, lng: -0.1496 },
    { name: 'Colindale', lat: 51.5955, lng: -0.2502 },
    { name: 'Colliers Wood', lat: 51.418, lng: -0.1778 },
    { name: 'Covent Garden', lat: 51.5129, lng: -0.1243 },
    { name: 'Crossharbour & London Arena', lat: 51.4957, lng: -0.0144 },
    { name: 'Croxley', lat: 51.647, lng: -0.4412 },
    { name: 'Custom House', lat: 51.5095, lng: 0.0276 },
    { name: 'Cutty Sark', lat: 51.4827, lng: -0.0096 },
    { name: 'Cyprus', lat: 51.5085, lng: 0.064 },
    { name: 'Dagenham East', lat: 51.5443, lng: 0.1655 },
    { name: 'Dagenham Heathway', lat: 51.5417, lng: 0.1469 },
    { name: 'Debden', lat: 51.6455, lng: 0.0838 },
    { name: 'Deptford Bridge', lat: 51.474, lng: -0.0216 },
    { name: 'Devons Road', lat: 51.5223, lng: -0.0173 },
    { name: 'Dollis Hill', lat: 51.552, lng: -0.2387 },
    { name: 'Ealing Broadway', lat: 51.5152, lng: -0.3017 },
    { name: 'Ealing Common', lat: 51.5101, lng: -0.2882 },
    { name: 'Earl\'s Court', lat: 51.492, lng: -0.1973 },
    { name: 'Eastcote', lat: 51.5765, lng: -0.397 },
    { name: 'East Acton', lat: 51.5168, lng: -0.2474 },
    { name: 'East Finchley', lat: 51.5874, lng: -0.165 },
    { name: 'East Ham', lat: 51.5394, lng: 0.0518 },
    { name: 'East India', lat: 51.5093, lng: -0.0021 },
    { name: 'East Putney', lat: 51.4586, lng: -0.2112 },
    { name: 'Edgware', lat: 51.6137, lng: -0.275 },
    { name: 'Edgware Road (B)', lat: 51.5199, lng: -0.1679 },
    { name: 'Edgware Road (C)', lat: 51.5203, lng: -0.17 },
    { name: 'Elephant & Castle', lat: 51.4943, lng: -0.1001 },
    { name: 'Elm Park', lat: 51.5496, lng: 0.1977 },
    { name: 'Elverson Road', lat: 51.4693, lng: -0.0174 },
    { name: 'Embankment', lat: 51.5074, lng: -0.1223 },
    { name: 'Epping', lat: 51.6937, lng: 0.1139 },
    { name: 'Euston', lat: 51.5282, lng: -0.1337 },
    { name: 'Euston Square', lat: 51.526, lng: -0.1359 },
    { name: 'Fairlop', lat: 51.596, lng: 0.0912 },
    { name: 'Farringdon', lat: 51.5203, lng: -0.1053 },
    { name: 'Finchley Central', lat: 51.6012, lng: -0.1932 },
    { name: 'Finchley Road', lat: 51.5472, lng: -0.1803 },
    { name: 'Finsbury Park', lat: 51.5642, lng: -0.1065 },
    { name: 'Fulham Broadway', lat: 51.4804, lng: -0.195 },
    { name: 'Gallions Reach', lat: 51.5096, lng: 0.0716 },
    { name: 'Gants Hill', lat: 51.5765, lng: 0.0663 },
    { name: 'Gloucester Road', lat: 51.4945, lng: -0.1829 },
    { name: 'Golders Green', lat: 51.5724, lng: -0.1941 },
    { name: 'Goldhawk Road', lat: 51.5018, lng: -0.2267 },
    { name: 'Goodge Street', lat: 51.5205, lng: -0.1347 },
    { name: 'Grange Hill', lat: 51.6132, lng: 0.0923 },
    { name: 'Great Portland Street', lat: 51.5238, lng: -0.1439 },
    { name: 'Greenford', lat: 51.5423, lng: -0.3456 },
    { name: 'Green Park', lat: 51.5067, lng: -0.1428 },
    { name: 'Greenwich', lat: 51.4781, lng: -0.0149 },
    { name: 'Gunnersbury', lat: 51.4915, lng: -0.2754 },
    { name: 'Hainault', lat: 51.603, lng: 0.0933 },
    { name: 'Hammersmith', lat: 51.4936, lng: -0.2251 },
    { name: 'Hampstead', lat: 51.5568, lng: -0.178 },
    { name: 'Hanger Lane', lat: 51.5302, lng: -0.2933 },
    { name: 'Harlesden', lat: 51.5362, lng: -0.2575 },
    { name: 'Harrow & Wealdstone', lat: 51.5925, lng: -0.3351 },
    { name: 'Harrow-on-the-Hill', lat: 51.5793, lng: -0.3366 },
    { name: 'Hatton Cross', lat: 51.4669, lng: -0.4227 },
    { name: 'Heathrow Terminals 1, 2 & 3', lat: 51.4713, lng: -0.4524 },
    { name: 'Heathrow Terminal 4', lat: 51.4598, lng: -0.4476 },
    { name: 'Heathrow Terminal 5', lat: 51.47006, lng: -0.49108 },
    { name: 'Hendon Central', lat: 51.5829, lng: -0.2259 },
    { name: 'Heron Quays', lat: 51.5033, lng: -0.0215 },
    { name: 'High Barnet', lat: 51.6503, lng: -0.1943 },
    { name: 'High Street Kensington', lat: 51.5009, lng: -0.1925 },
    { name: 'Highbury & Islington', lat: 51.546, lng: -0.104 },
    { name: 'Highgate', lat: 51.5777, lng: -0.1458 },
    { name: 'Hillingdon', lat: 51.5538, lng: -0.4499 },
    { name: 'Holborn', lat: 51.5174, lng: -0.12 },
    { name: 'Holland Park', lat: 51.5075, lng: -0.206 },
    { name: 'Holloway Road', lat: 51.5526, lng: -0.1132 },
    { name: 'Hornchurch', lat: 51.5539, lng: 0.2184 },
    { name: 'Hounslow Central', lat: 51.4713, lng: -0.3665 },
    { name: 'Hounslow East', lat: 51.4733, lng: -0.3564 },
    { name: 'Hounslow West', lat: 51.4734, lng: -0.3855 },
    { name: 'Hyde Park Corner', lat: 51.5027, lng: -0.1527 },
    { name: 'Ickenham', lat: 51.5619, lng: -0.4421 },
    { name: 'Island Gardens', lat: 51.4871, lng: -0.0101 },
    { name: 'Kennington', lat: 51.4884, lng: -0.1053 },
    { name: 'Kensal Green', lat: 51.5304, lng: -0.225 },
    { name: 'Kensington (Olympia)', lat: 51.4983, lng: -0.2106 },
    { name: 'Kentish Town', lat: 51.5507, lng: -0.1402 },
    { name: 'Kenton', lat: 51.5816, lng: -0.3162 },
    { name: 'Kew Gardens', lat: 51.477, lng: -0.285 },
    { name: 'Kilburn', lat: 51.5471, lng: -0.2047 },
    { name: 'Kilburn Park', lat: 51.5351, lng: -0.1939 },
    { name: 'King George V', lat: 51.502, lng: 0.0627 },
    { name: 'King\'s Cross St. Pancras', lat: 51.5308, lng: -0.1238 },
    { name: 'Knightsbridge', lat: 51.5015, lng: -0.1607 },
    { name: 'Ladbroke Grove', lat: 51.5172, lng: -0.2107 },
    { name: 'Lambeth North', lat: 51.4991, lng: -0.1115 },
    { name: 'Lancaster Gate', lat: 51.5119, lng: -0.1756 },
    { name: 'Latimer Road', lat: 51.5139, lng: -0.2172 },
    { name: 'Leicester Square', lat: 51.5113, lng: -0.1281 },
    { name: 'Lewisham', lat: 51.4657, lng: -0.0142 },
    { name: 'Leyton', lat: 51.5566, lng: -0.0053 },
    { name: 'Leytonstone', lat: 51.5683, lng: 0.0083 },
    { name: 'Limehouse', lat: 51.5123, lng: -0.0396 },
    { name: 'Liverpool Street', lat: 51.5178, lng: -0.0823 },
    { name: 'London Bridge', lat: 51.5052, lng: -0.0864 },
    { name: 'London City Airport', lat: 51.5037, lng: 0.0488 },
    { name: 'Loughton', lat: 51.6412, lng: 0.0558 },
    { name: 'Maida Vale', lat: 51.53, lng: -0.1854 },
    { name: 'Manor House', lat: 51.5712, lng: -0.0958 },
    { name: 'Mansion House', lat: 51.5122, lng: -0.094 },
    { name: 'Marble Arch', lat: 51.5136, lng: -0.1586 },
    { name: 'Marylebone', lat: 51.5225, lng: -0.1631 },
    { name: 'Mile End', lat: 51.5249, lng: -0.0332 },
    { name: 'Mill Hill East', lat: 51.6082, lng: -0.2103 },
    { name: 'Monument', lat: 51.5108, lng: -0.0863 },
    { name: 'Moorgate', lat: 51.5186, lng: -0.0886 },
    { name: 'Moor Park', lat: 51.6294, lng: -0.432 },
    { name: 'Morden', lat: 51.4022, lng: -0.1948 },
    { name: 'Mornington Crescent', lat: 51.5342, lng: -0.1387 },
    { name: 'Mudchute', lat: 51.4902, lng: -0.0145 },
    { name: 'Neasden', lat: 51.5542, lng: -0.2503 },
    { name: 'Nine Elms', lat: 51.4799, lng: -0.1284 },
    { name: 'Newbury Park', lat: 51.5756, lng: 0.0899 },
    { name: 'New Cross', lat: 51.4767, lng: -0.0327 },
    { name: 'New Cross Gate', lat: 51.4757, lng: -0.0402 },
    { name: 'Northfields', lat: 51.4995, lng: -0.3142 },
    { name: 'North Greenwich', lat: 51.5005, lng: 0.0039 },
    { name: 'Northolt', lat: 51.5483, lng: -0.3687 },
    { name: 'Northwick Park', lat: 51.5784, lng: -0.3184 },
    { name: 'Northwood', lat: 51.6111, lng: -0.424 },
    { name: 'Northwood Hills', lat: 51.6004, lng: -0.4092 },
    { name: 'North Acton', lat: 51.5237, lng: -0.2597 },
    { name: 'North Ealing', lat: 51.5175, lng: -0.2887 },
    { name: 'North Harrow', lat: 51.5846, lng: -0.3626 },
    { name: 'North Wembley', lat: 51.5621, lng: -0.3034 },
    { name: 'Notting Hill Gate', lat: 51.5094, lng: -0.1967 },
    { name: 'Oakwood', lat: 51.6476, lng: -0.1318 },
    { name: 'Old Street', lat: 51.5263, lng: -0.0873 },
    { name: 'Osterley', lat: 51.4813, lng: -0.3522 },
    { name: 'Oval', lat: 51.4819, lng: -0.113 },
    { name: 'Oxford Circus', lat: 51.515, lng: -0.1415 },
    { name: 'Paddington', lat: 51.5154, lng: -0.1755 },
    { name: 'Park Royal', lat: 51.527, lng: -0.2841 },
    { name: 'Parsons Green', lat: 51.4753, lng: -0.2011 },
    { name: 'Perivale', lat: 51.5366, lng: -0.3232 },
    { name: 'Piccadilly Circus', lat: 51.5098, lng: -0.1342 },
    { name: 'Pimlico', lat: 51.4893, lng: -0.1334 },
    { name: 'Pinner', lat: 51.5926, lng: -0.3805 },
    { name: 'Plaistow', lat: 51.5313, lng: 0.0172 },
    { name: 'Pontoon Dock', lat: 51.5021, lng: 0.0319 },
    { name: 'Poplar', lat: 51.5077, lng: -0.0173 },
    { name: 'Preston Road', lat: 51.572, lng: -0.2954 },
    { name: 'Prince Regent', lat: 51.5093, lng: 0.0336 },
    { name: 'Pudding Mill Lane', lat: 51.5343, lng: -0.0139 },
    { name: 'Putney Bridge', lat: 51.4682, lng: -0.2089 },
    { name: 'Queen\'s Park', lat: 51.5341, lng: -0.2047 },
    { name: 'Queensbury', lat: 51.5942, lng: -0.2861 },
    { name: 'Queensway', lat: 51.5107, lng: -0.1877 },
    { name: 'Ravenscourt Park', lat: 51.4942, lng: -0.2359 },
    { name: 'Rayners Lane', lat: 51.5753, lng: -0.3714 },
    { name: 'Redbridge', lat: 51.5763, lng: 0.0454 },
    { name: 'Regent\'s Park', lat: 51.5234, lng: -0.1466 },
    { name: 'Richmond', lat: 51.4633, lng: -0.3013 },
    { name: 'Rickmansworth', lat: 51.6404, lng: -0.4733 },
    { name: 'Roding Valley', lat: 51.6171, lng: 0.0439 },
    { name: 'Rotherhithe', lat: 51.501, lng: -0.0525 },
    { name: 'Royal Albert', lat: 51.5084, lng: 0.0465 },
    { name: 'Royal Oak', lat: 51.519, lng: -0.188 },
    { name: 'Royal Victoria', lat: 51.5091, lng: 0.0181 },
    { name: 'Ruislip', lat: 51.5715, lng: -0.4213 },
    { name: 'Ruislip Gardens', lat: 51.5606, lng: -0.4103 },
    { name: 'Ruislip Manor', lat: 51.5732, lng: -0.4125 },
    { name: 'Russell Square', lat: 51.523, lng: -0.1244 },
    { name: 'Seven Sisters', lat: 51.5822, lng: -0.0749 },
    { name: 'Shadwell', lat: 51.5117, lng: -0.056 },
    { name: 'Shepherd\'s Bush (C)', lat: 51.5046, lng: -0.2187 },
    { name: 'Shepherd\'s Bush (H)', lat: 51.5058, lng: -0.2265 },
    { name: 'Shoreditch', lat: 51.5227, lng: -0.0708 },
    { name: 'Sloane Square', lat: 51.4924, lng: -0.1565 },
    { name: 'Snaresbrook', lat: 51.5808, lng: 0.0216 },
    { name: 'Southfields', lat: 51.4454, lng: -0.2066 },
    { name: 'South Ealing', lat: 51.5011, lng: -0.3072 },
    { name: 'South Harrow', lat: 51.5646, lng: -0.3521 },
    { name: 'South Kensington', lat: 51.4941, lng: -0.1738 },
    { name: 'South Kenton', lat: 51.5701, lng: -0.3081 },
    { name: 'South Quay', lat: 51.5007, lng: -0.0191 },
    { name: 'South Ruislip', lat: 51.5569, lng: -0.3988 },
    { name: 'South Wimbledon', lat: 51.4154, lng: -0.1919 },
    { name: 'South Woodford', lat: 51.5917, lng: 0.0275 },
    { name: 'Southgate', lat: 51.6322, lng: -0.128 },
    { name: 'Southwark', lat: 51.504, lng: -0.1052 },
    { name: 'Stamford Brook', lat: 51.495, lng: -0.2459 },
    { name: 'Stanmore', lat: 51.6194, lng: -0.3028 },
    { name: 'Stepney Green', lat: 51.5221, lng: -0.047 },
    { name: 'Stockwell', lat: 51.4723, lng: -0.123 },
    { name: 'Stonebridge Park', lat: 51.5439, lng: -0.2759 },
    { name: 'Stratford', lat: 51.5416, lng: -0.0042 },
    { name: 'St. James\'s Park', lat: 51.4994, lng: -0.1335 },
    { name: 'St. John\'s Wood', lat: 51.5347, lng: -0.174 },
    { name: 'St. Paul\'s', lat: 51.5146, lng: -0.0973 },
    { name: 'Sudbury Hill', lat: 51.5569, lng: -0.3366 },
    { name: 'Sudbury Town', lat: 51.5507, lng: -0.3156 },
    { name: 'Surrey Quays', lat: 51.4933, lng: -0.0478 },
    { name: 'Swiss Cottage', lat: 51.5432, lng: -0.1738 },
    { name: 'Temple', lat: 51.5111, lng: -0.1141 },
    { name: 'Theydon Bois', lat: 51.6717, lng: 0.1033 },
    { name: 'Tooting Bec', lat: 51.4361, lng: -0.1598 },
    { name: 'Tooting Broadway', lat: 51.4275, lng: -0.168 },
    { name: 'Tottenham Court Road', lat: 51.5165, lng: -0.131 },
    { name: 'Tottenham Hale', lat: 51.5882, lng: -0.0594 },
    { name: 'Totteridge & Whetstone', lat: 51.6302, lng: -0.1791 },
    { name: 'Tower Gateway', lat: 51.5106, lng: -0.0743 },
    { name: 'Tower Hill', lat: 51.5098, lng: -0.0766 },
    { name: 'Tufnell Park', lat: 51.5567, lng: -0.1374 },
    { name: 'Turnham Green', lat: 51.4951, lng: -0.2547 },
    { name: 'Turnpike Lane', lat: 51.5904, lng: -0.1028 },
    { name: 'Upminster', lat: 51.559, lng: 0.251 },
    { name: 'Upminster Bridge', lat: 51.5582, lng: 0.2343 },
    { name: 'Upney', lat: 51.5385, lng: 0.1014 },
    { name: 'Upton Park', lat: 51.5352, lng: 0.0343 },
    { name: 'Uxbridge', lat: 51.5463, lng: -0.4786 },
    { name: 'Vauxhall', lat: 51.4861, lng: -0.1253 },
    { name: 'Victoria', lat: 51.4965, lng: -0.1447 },
    { name: 'Walthamstow Central', lat: 51.583, lng: -0.0195 },
    { name: 'Wanstead', lat: 51.5775, lng: 0.0288 },
    { name: 'Wapping', lat: 51.5043, lng: -0.0558 },
    { name: 'Warren Street', lat: 51.5247, lng: -0.1384 },
    { name: 'Warwick Avenue', lat: 51.5235, lng: -0.1835 },
    { name: 'Waterloo', lat: 51.5036, lng: -0.1143 },
    { name: 'Watford', lat: 51.6573, lng: -0.4177 },
    { name: 'Wembley Central', lat: 51.5519, lng: -0.2963 },
    { name: 'Wembley Park', lat: 51.5635, lng: -0.2795 },
    { name: 'Westbourne Park', lat: 51.521, lng: -0.2011 },
    { name: 'Westferry', lat: 51.5097, lng: -0.0265 },
    { name: 'Westminster', lat: 51.501, lng: -0.1254 },
    { name: 'West Acton', lat: 51.518, lng: -0.2809 },
    { name: 'West Brompton', lat: 51.4872, lng: -0.1953 },
    { name: 'West Finchley', lat: 51.6095, lng: -0.1883 },
    { name: 'West Ham', lat: 51.5287, lng: 0.0056 },
    { name: 'West Hampstead', lat: 51.5469, lng: -0.1906 },
    { name: 'West Harrow', lat: 51.5795, lng: -0.3533 },
    { name: 'West India Quay', lat: 51.507, lng: -0.0203 },
    { name: 'West Kensington', lat: 51.4907, lng: -0.2065 },
    { name: 'West Ruislip', lat: 51.5696, lng: -0.4376 },
    { name: 'West Silvertown', lat: 51.5027, lng: 0.0226 },
    { name: 'Whitechapel', lat: 51.5194, lng: -0.0612 },
    { name: 'White City', lat: 51.512, lng: -0.2239 },
    { name: 'Willesden Green', lat: 51.5492, lng: -0.2215 },
    { name: 'Willesden Junction', lat: 51.5326, lng: -0.2478 },
    { name: 'Wimbledon', lat: 51.4214, lng: -0.2064 },
    { name: 'Wimbledon Park', lat: 51.4343, lng: -0.1992 },
    { name: 'Woodford', lat: 51.607, lng: 0.0341 },
    { name: 'Wood Green', lat: 51.5975, lng: -0.1097 },
    { name: 'Wood Lane', lat: 51.510031, lng: -0.224301 },
    { name: 'Woodside Park', lat: 51.6179, lng: -0.1856 }
  ],
  'Manchester': [
    { name: 'Piccadilly', lat: 53.4773, lng: -2.2309 },
    { name: 'Victoria', lat: 53.4861, lng: -2.2426 },
    { name: 'Oxford Road', lat: 53.4734, lng: -2.2420 },
    { name: 'Deansgate', lat: 53.4740, lng: -2.2500 },
    { name: 'St Peter\'s Square', lat: 53.4776, lng: -2.2430 },
    { name: 'Market Street', lat: 53.4830, lng: -2.2420 },
    { name: 'Shudehill', lat: 53.4850, lng: -2.2400 },
    { name: 'Exchange Square', lat: 53.4840, lng: -2.2380 }
  ],
  'Birmingham': [
    { name: 'New Street', lat: 52.4779, lng: -1.8986 },
    { name: 'Moor Street', lat: 52.4778, lng: -1.8940 },
    { name: 'Snow Hill', lat: 52.4839, lng: -1.8990 },
    { name: 'Five Ways', lat: 52.4640, lng: -1.9100 },
    { name: 'University', lat: 52.4500, lng: -1.9300 }
  ],
  'Liverpool': [
    { name: 'Lime Street', lat: 53.4076, lng: -2.9785 },
    { name: 'Central', lat: 53.4048, lng: -2.9792 },
    { name: 'James Street', lat: 53.4044, lng: -2.9916 },
    { name: 'Moorfields', lat: 53.4089, lng: -2.9889 }
  ],
  'Leeds': [
    { name: 'Leeds', lat: 53.7948, lng: -1.5486 },
    { name: 'City Square', lat: 53.7969, lng: -1.5456 },
    { name: 'Trinity', lat: 53.7960, lng: -1.5440 }
  ],
  'Sheffield': [
    { name: 'Sheffield', lat: 53.3781, lng: -1.4620 },
    { name: 'Meadowhall', lat: 53.4130, lng: -1.4110 }
  ],
  'Newcastle': [
    { name: 'Central', lat: 54.9681, lng: -1.6174 },
    { name: 'Monument', lat: 54.9700, lng: -1.6100 },
    { name: 'Haymarket', lat: 54.9750, lng: -1.6100 }
  ],
  'Bristol': [
    { name: 'Temple Meads', lat: 51.4491, lng: -2.5800 },
    { name: 'Bristol Parkway', lat: 51.5139, lng: -2.5420 }
  ],
  'Edinburgh': [
    { name: 'Waverley', lat: 55.9521, lng: -3.1881 },
    { name: 'Haymarket', lat: 55.9456, lng: -3.2181 }
  ],
  'Glasgow': [
    { name: 'Central', lat: 55.8598, lng: -4.2574 },
    { name: 'Queen Street', lat: 55.8619, lng: -4.2519 },
    { name: 'Buchanan Street', lat: 55.8640, lng: -4.2520 }
  ]
};

// Sample venue coordinates for major cities (you'd get these from geocoding)
const VENUE_COORDINATES = {
  'London': { lat: 51.5074, lng: -0.1278 },
  'Manchester': { lat: 53.4808, lng: -2.2426 },
  'Birmingham': { lat: 52.4862, lng: -1.8904 },
  'Liverpool': { lat: 53.4084, lng: -2.9916 },
  'Leeds': { lat: 53.8008, lng: -1.5491 },
  'Sheffield': { lat: 53.3811, lng: -1.4701 },
  'Newcastle': { lat: 54.9783, lng: -1.6178 },
  'Bristol': { lat: 51.4545, lng: -2.5879 },
  'Edinburgh': { lat: 55.9533, lng: -3.1883 },
  'Glasgow': { lat: 55.8642, lng: -4.2518 }
};

/**
 * Calculate distance between two points using Haversine formula
 * @param {number} lat1 - Latitude of first point
 * @param {number} lng1 - Longitude of first point
 * @param {number} lat2 - Latitude of second point
 * @param {number} lng2 - Longitude of second point
 * @returns {number} Distance in kilometers
 */
const calculateDistance = (lat1, lng1, lat2, lng2) => {
  const R = 6371; // Earth's radius in kilometers
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng/2) * Math.sin(dLng/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
};

/**
 * Extract city name from venue address
 * @param {string} address - Venue address
 * @param {string} venueCity - City from venue object
 * @returns {string} City name
 */
const extractCityFromAddress = (address, venueCity = null) => {
  if (!address) return venueCity || 'London';
  
  // If venue has a city property, use that first
  if (venueCity) {
    return venueCity;
  }
  
  // Common patterns for UK addresses
  const addressParts = address.split(',');
  const lastPart = addressParts[addressParts.length - 1]?.trim();
  const secondLastPart = addressParts[addressParts.length - 2]?.trim();
  
  // Check if last part is a postcode (UK postcode pattern)
  const postcodePattern = /^[A-Z]{1,2}[0-9][A-Z0-9]?\s?[0-9][A-Z]{2}$/i;
  if (postcodePattern.test(lastPart)) {
    return secondLastPart || 'London';
  }
  
  // Return the last part as city
  return lastPart || 'London';
};

/**
 * Find the closest metro station to a venue
 * @param {number} venueLat - Venue latitude
 * @param {number} venueLng - Venue longitude
 * @param {string} city - City name
 * @returns {Object|null} Closest metro station info
 */
const findClosestMetroStation = (venueLat, venueLng, city) => {
  const stations = METRO_STATIONS_DB[city] || METRO_STATIONS_DB['London'];
  
  if (!stations || stations.length === 0) {
    return null;
  }
  
  let closest = null;
  let minDistance = Infinity;
  
  stations.forEach(station => {
    const distance = calculateDistance(venueLat, venueLng, station.lat, station.lng);
    if (distance < minDistance) {
      minDistance = distance;
      closest = { 
        ...station, 
        distance: distance,
        walkingTime: Math.round(distance * 12) // Rough estimate: 5km/h walking speed
      };
    }
  });
  
  return closest;
};

/**
 * Get venue coordinates (simplified - in real app you'd geocode the address)
 * @param {string} address - Venue address
 * @param {string} city - City name
 * @param {number} venueId - Venue ID for variation
 * @returns {Object} Coordinates {lat, lng}
 */
const getVenueCoordinates = (address, city = null, venueId = 1) => {
  const extractedCity = city || extractCityFromAddress(address);
  const baseCoords = VENUE_COORDINATES[extractedCity] || VENUE_COORDINATES['London'];
  
  // Add some variation based on venue ID to simulate different areas within the city
  // This creates more realistic distance variations
  const variation = 0.01; // ~1km variation
  const latOffset = (Math.sin(venueId * 0.5) * variation);
  const lngOffset = (Math.cos(venueId * 0.3) * variation);
  
  return {
    lat: baseCoords.lat + latOffset,
    lng: baseCoords.lng + lngOffset
  };
};

/**
 * Calculate distance from closest metro station
 * @param {Object} venue - Venue object with address and city
 * @returns {Object|null} Metro distance info
 */
export const calculateMetroDistance = (venue) => {
  if (!venue) {
    return null;
  }

  const override =
    VENUE_METRO_OVERRIDES[resolveVenueId(venue)] ||
    VENUE_METRO_OVERRIDES_BY_NAME[normalizeVenueNameKey(venue?.name ?? venue?.venue_name)];
  if (override) {
    return {
      station: override.station,
      walkingTime: override.walkingTime,
      distance: override.distance ?? null,
      city: override.city || venue.city || extractCityFromAddress(venue.area || venue.address, venue.city) || 'London'
    };
  }
  
  try {
    // Use real coordinates from API if available, otherwise fallback to simulated
    let venueCoords;
    let city;
    
    if (venue.latitude && venue.longitude) {
      // Use real coordinates from API
      venueCoords = { lat: venue.latitude, lng: venue.longitude };
      city = venue.city || extractCityFromAddress(venue.area || venue.address, venue.city);
    } else {
      // Fallback to simulated coordinates
      const address = venue.area || venue.address;
      if (!address) return null;
      city = extractCityFromAddress(address, venue.city);
      venueCoords = getVenueCoordinates(address, city, venue.id);
    }
    
    const closestStation = findClosestMetroStation(venueCoords.lat, venueCoords.lng, city);
    
    if (!closestStation) {
      return null;
    }
    
    return {
      station: closestStation.name,
      distance: closestStation.distance,
      walkingTime: closestStation.walkingTime,
      city: city
    };
  } catch (error) {
    return null;
  }
};

/**
 * Format metro distance for display
 * @param {Object} venue - Venue object
 * @returns {string} Formatted distance string
 */
export const getMetroDistanceText = (venue) => {
  const metroInfo = calculateMetroDistance(venue);
  
  if (!metroInfo) {
    const city = extractCityFromAddress(venue?.area || venue?.address, venue?.city);
    return `5 min from ${city}`;
  }

  const station = metroInfo.station;
  const walkingTime = metroInfo.walkingTime;

  // Format walking time - ensure minimum 1 minute
  let timeText;
  if (walkingTime < 1) {
    timeText = '1 min';
  } else if (walkingTime < 60) {
    timeText = `${Math.round(walkingTime)} min`;
  } else {
    const hours = Math.floor(walkingTime / 60);
    const minutes = Math.round(walkingTime % 60);
    timeText = minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
  }
  
  return `${timeText} walk from ${station}`;
};

/**
 * Get all metro stations for a city (for debugging or future use)
 * @param {string} city - City name
 * @returns {Array} Array of metro stations
 */
export const getMetroStationsForCity = (city) => {
  return METRO_STATIONS_DB[city] || [];
};

/**
 * Add a new metro station to the database
 * @param {string} city - City name
 * @param {Object} station - Station object {name, lat, lng}
 */
export const addMetroStation = (city, station) => {
  if (!METRO_STATIONS_DB[city]) {
    METRO_STATIONS_DB[city] = [];
  }
  METRO_STATIONS_DB[city].push(station);
};

// Export the database for external access if needed
export { METRO_STATIONS_DB };
